import { Model } from '@vuex-orm/core';

import defaultAvatar from '@/static/images/default_avatar.svg';
import defaultFavicon from '@/static/images/default_favicon.png';
import defaultLogo from '@/static/images/default_logo.svg';

export const defaultBrandingColours = {
    primaryBackground: '#5ABDF9',
    primaryLight: '#DFEAF1',
    primaryText: '#0670B1'
};

export const defaultBrandingImages = {
    logo: defaultLogo,
    avatar: defaultAvatar,
    favicon: defaultFavicon
};

export class Branding extends Model {
    static name = 'Branding';
    static entity = 'branding';

    static fields() {
        return {
            id: this.string(null),
            name: this.string(null),
            _text: this.attr({}),
            _colours: this.attr(defaultBrandingColours),
            _images: this.attr(defaultBrandingImages),
            _dark: this.boolean(false),
            _custom_app_url: this.string(null).nullable()
        };
    }

    static mock() {
        return {};
    }

    set text(payload) {
        this._text = payload ? payload : null;
    }

    get text() {
        return this._text || {};
    }

    set colours(payload) {
        this._colours = payload ? { ...defaultBrandingColours, ...payload } : defaultBrandingColours;
    }

    get colours() {
        return { ...defaultBrandingColours, ...this._colours };
    }

    set images(payload) {
        this._images = payload ? { ...defaultBrandingImages, ...payload } : defaultBrandingImages;
    }

    get images() {
        return { ...defaultBrandingImages, ...this._images };
    }

    set dark(payload) {
        this._dark = payload ? payload : false;
    }

    get dark() {
        return this._dark;
    }

    get custom_app_url() {
        return this._custom_app_url;
    }

    get colour() {
        return key => this.colours[`${key}`];
    }

    get image() {
        return key => this.images[`${key}`];
    }
}

export default Branding;
